import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Observable, Subject, Subscription, interval, of } from "rxjs";
import { catchError, last, map, switchMap, takeUntil, takeWhile, tap } from "rxjs/operators";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Sucursal } from "src/app/models/Sucursal";
import { Usuario } from "src/app/models/Usuario/Usuario";
import { AuthService } from "src/app/modules/auth";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { SortType } from "@swimlane/ngx-datatable";
import { UtilitiesService } from "src/app/services/utilities.service";
import { SoporteButton } from "src/app/shared/models/SoporteButton.enum";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { DatosFacturacion, EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { EmisorService } from "src/app/services/emisor.service";
import { PlanFacturacion } from "src/app/models/PlanesUsuario/PlanFacturacion";
import { Response } from "src/app/shared/models/Response";
import * as moment from "moment";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { Adicional } from "src/app/models/Emisor/Adicional";
import { CypressService } from "src/app/services/cypress.service";
import { ChartOptions } from "src/app/models/ChartOptions";

@Component({
	selector: "app-user-plan",
	templateUrl: "./plan-panel.component.html",
	styleUrls: ["./plan-panel.component.scss"],
})
export class PlanPanelComponent implements OnInit {
	SortType = SortType;
	public loading: boolean = false;
	public user: SessionUser;
	public currentUser: Usuario = new Usuario();
	public currentEmisorObject: Emisor;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public emisores: Emisor[] = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
	public usuarioId: string;
	public emisorId: string;
	private paymentPlanModal: NgbModalRef;
	public facturasPlan: PlanFacturacion[];
	public adicionales: Adicional[];

	public rowsPlanes: PlanUsuario[] = [];
	public planActual: PlanUsuario;
	public planSeleccionado: Plan;

	public rowsDatosFacturacion: EmpresaFacturacion[] = [];
	public datosFacturacion: EmpresaFacturacion;
	public chartOptions: Partial<ChartOptions>;

	public resumenCuenta: Resumen;
	public certificaciones: CertificacionPrecio[];
	public planes: Plan[];
	public nuevaFechaCaducidad: moment.Moment;
	public hasAdicionales: boolean;
	public fechaActual = moment();
	public planActualNuevo: Plan;
	//this.nuevaFechaCaducidad = moment(this.planUsuarioPagado.fechaCaducidad).add(resumen.meses, "months");

	constructor(
		public utilities: UtilitiesService,
		private pagoService: PagoUsuarioService,
		private tokenService: TokenStorageService,
		private userService: UsuarioService,
		public modalService: NgbModal,
		public permissions: PermissionService,
		public emisorService: EmisorService,
		public planService: PlanUsuarioService,
		private router: Router,
		public authService: AuthService,
		public datosFacturacionServicce: DatosFacturacionService,
		private localStorage: LocalStorageService,
		private cypressService: CypressService,
		private ref: ChangeDetectorRef
	) {
		this.usuarioId = tokenService.getUser().id;
		this.user = tokenService.getUser() as SessionUser;
		this.emisorId = this.tokenService.getCompany();

		const emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.currentEmisorObject = emisoresSource.find((x) => x.emisorId == this.tokenService.getCompany());
	}

	ngOnInit(): void {
	}

	ngAfterViewInit() {
		this.loadData();
		
	}

	loadData() {
		this.loading = true;
		this.planService
			.getContratacionDataByCompany(this.emisorId)
			.subscribe(
				(pagedData) => {
					let elements = pagedData as PlanUsuario[];
					this.ref.detectChanges();
					elements.forEach((row) => { });
					this.rowsPlanes = [...elements];
					this.planActual = this.rowsPlanes.find((x) => x.emisorId == this.emisorId);
					this.planService.getInitialData().subscribe((data) => {
						this.planes = data.planes; 
						this.planActualNuevo = this.planes.find((x) => x.nombre === this.planActual.nombrePlan && x.antiguedad === "Nuevo");
					});
					this.planService.getDteChartData(this.emisorId).subscribe(
						(response) => {
							const monthData = response.data; 
							this.chartOptions = {
								series: [
									{
										name: 'DTEs emitidos',
										data: monthData.map(m => m.count)
									}
								],
								chart: {
									height: 300,
									width: '100%',
									type: 'line', // Puedes cambiar a "scatter" si lo prefieres
									toolbar: {
										show: false
									}
								},
								dataLabels: {
								  	enabled: false
								},
								stroke: {
								  	curve: 'straight'
								},
								title: {
									text: 'DTEs emitidos por SimpleFactura',
									align: 'center'
								},
								xaxis: {
									type: 'category',
									categories: monthData.map(m => m.monthYear)
								}
							};
							this.loading = false;
							this.ref.detectChanges();
						},
						(error) => {
							this.handleError(error);
							this.loading = false;
						}
					);
				},
				(error) => {
					console.log("ERROR", error);
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	setPagefromResponse(currentPage: Page, data: PagedResponse<PlanUsuario>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	filtro(event) { }
	payPlan(modalRef) {
		this.loading = true;
		//Trae el listado de certificaciones con sus precios y los planes existentes
		this.planService.getInitialData().subscribe((data) => {
			this.planes = data.planes;
			this.certificaciones = data.certificaciones;
			this.userService.getUser(this.user.id, this.emisorId).subscribe((response) => {
				this.loading = false;
				this.ref.detectChanges();
				if (response.data.planesUsuario.length == 0) {
					Swal.fire({
						title: "¡Ups! Un problema",
						text: "Solo el administrador de la empresa puede pagar el plan.",
						icon: "warning",
					});
					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.planActual.emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.find((x) => x.emisorId == this.planActual.emisorId);
				});
				this.handleUserData(response.data, "payment");
				this.paymentPlanModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "xl",
				});
				this.loading = false;
				this.ref.detectChanges();
			}, this.handleError);
		});
	}

	changePlan(modalRef) {
		this.loading = true;
		//this.planSeleccionado = null;
		//Trae el listado de certificaciones con sus precios y los planes existentes
		this.planService.getInitialData().subscribe((data) => {
			 const fechaCorte = moment(this.planActual.fechaCorte);
			 const fechaActual = moment();
			 const planesNuevos = data.planes.filter(plan => plan.id === this.planActual.idPlanSf && plan.antiguedad === 'Nuevo');
			 if (fechaActual.isSameOrAfter(fechaCorte) || planesNuevos.length > 0 ) {
				this.planes = data.planes.filter(plan => plan.antiguedad === 'Nuevo');
			} 
			else {
				const planesFiltrados = data.planes.filter(plan =>
					plan.antiguedad === 'Nuevo' && plan.nombre !== this.planActual.nombrePlan
				  );
				  const indiceOriginal = data.planes.findIndex(plan => plan.id === this.planActual.idPlanSf);
				  let posicionInsercion = 0;
				  for (const plan of planesFiltrados) {
					const indicePlan = data.planes.findIndex(p => p.nombre === plan.nombre);
					if (indicePlan < indiceOriginal) {
					  posicionInsercion++;
					}
				  }
				  this.planes = [...planesFiltrados];
				  const planCorrespondiente = data.planes.find(
					(p) => p.id === this.planActual.idPlanSf
				  );
				  if (planCorrespondiente) {
					planCorrespondiente.id = this.planActual.idPlanSf;
					this.planes.splice(posicionInsercion, 0, planCorrespondiente);
				  }

			}
			this.certificaciones = data.certificaciones;
			this.userService.getUser(this.user.id, this.emisorId).subscribe((response) => {
				if (response.data.planesUsuario.length == 0) {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						title: "¡Ups! Un problema",
						text: "Solo el administrador de la empresa puede cambiar el plan.",
						icon: "warning",
					});

					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.planActual.emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.find((x) => x.emisorId == this.planActual.emisorId);
				});
				this.handleUserData(response.data, "change");

				this.paymentPlanModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "xl",
				});
				if (this.planSeleccionado == null) {
					this.planSeleccionado = this.planes.find((x) => x.id === this.planActual.idPlanSf);
				}
				this.loading = false;
				this.ref.detectChanges();
			}, this.handleError);
		});
	}

	extendPlan(modalRef) {
		this.loading = true;
		//Trae el listado de certificaciones con sus precios y los planes existentes
		this.planService.getInitialData().subscribe((data) => {
			this.planes = data.planes;
			this.certificaciones = data.certificaciones;
			this.userService.getUser(this.user.id, this.emisorId).subscribe((response) => {
				this.loading = false;
				this.ref.detectChanges();
				if (response.data.planesUsuario.length == 0) {

					Swal.fire({
						title: "¡Ups! Un problema",
						text: "Solo el administrador de la empresa puede extender el plan.",
						icon: "warning",
					});
					return;
				}
				this.datosFacturacionServicce.getData(this.usuarioId, this.emisorId).subscribe((data) => {
					this.rowsDatosFacturacion = data;
					this.datosFacturacion = data.find((x) => x.emisorId == this.planActual.emisorId);
				});
				this.handleUserData(response.data, "extend");

				this.paymentPlanModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "xl",
				});
				this.loading = false;
				this.ref.detectChanges();
			}, this.handleError);
		});
	}

	handleUserData(userData: any, type: string): void {
		let planActual: PlanUsuario;
		if (this.planActual.idPlanUsuario != null && this.planActual.idPlanUsuario != undefined) {
			//Existe un plan
			planActual = userData.planesUsuario.find((y) => y.idPlanUsuario === this.planActual.idPlanUsuario);
			this.certificaciones.forEach((x) => {
				x.solicitada = false;
			});
			userData.certificacionesPendientes.forEach((x) => {
				let certTemp = this.certificaciones.find((z) => z.codigoPrincipal === x.codigoPrincipal);
				certTemp.solicitada = true;
			});
			this.handlePlanActual(userData, planActual);
		} else {
			//Es posible que el IdUsuario esté dentro de los planes del usuario
			planActual = userData.planesUsuario[0];
			this.handlePlanActual(userData, planActual);
		}

		if (!this.user.configured && planActual && planActual.pagado && !planActual.activo) {
			//En realidad no se debería hacer nada y dejar todo por defecto.
			//this.handleNotPlanActual(userData, planActual);
			let resumenCuenta = new Resumen();
			resumenCuenta.pagado = planActual.pagado;
			resumenCuenta.idPlanUsuario = planActual.idPlanUsuario;
			resumenCuenta.idPlanSf = planActual.idPlanSf;
			resumenCuenta.formaPago = planActual.formaPago;
			resumenCuenta.nombrePlan = planActual.nombrePlan;
			resumenCuenta.change = type == "change";
			resumenCuenta.extend = type == "extend";
			this.notifyResumen(resumenCuenta);
		}

		//this.actualizarCertificaciones.emit(this.certificaciones);
		// if (userData.certificacionesPendientes.length === 0) {
		// 	this.tipoCertificacion = "propia";
		// }
	}
 
	handlePlanActual(userData: any, planActual: PlanUsuario): void {
		if (!this.planActual.fechaCorte || this.planActual.fechaCorte < this.planActual.fechaCaducidad){
			this.planSeleccionado = this.planes.find((x) => x.nombre === this.planActual.nombrePlan && x.antiguedad == 'Nuevo');
		} else{
			this.planSeleccionado = this.planes.find((x) => x.nombre === planActual.nombrePlan && x.antiguedad == 'Antiguo');
		}
		
		//this.planUsuarioPagado = planActual;
		if (planActual.activo == false) {
			//this.idContratacion = planActual.idContratacion;
			this.certificaciones.forEach((x) => {
				x.idPlanUsuario = planActual.idPlanUsuario;
				x.solicitada = userData.certificacionesPendientes.some((y) => y.codigoPrincipal === x.codigoPrincipal);
			});
			this.ref.detectChanges();
		} else {
			setTimeout(() => {
				this.pagoService.triggerCalculations();
			}, 0);
		}
		this.certificaciones.forEach((x) => {
			x.idPlanUsuario = planActual.idPlanUsuario;
		});
		// TODO this.nmeses = planActual.meses;
		// TODO this.resumenCuenta.formaPago = planActual.formaPago;
	}

	handleError(error): void {
		Swal.fire({
			title: "Error en datos",
			text: "No fue posible obtener los datos del usuario actual, favor intente nuevamente",
			icon: "error",
		});
	}

	notifyResumen(resumen: Resumen): void {
		this.nuevaFechaCaducidad = moment(resumen.fechaTermino);
		this.resumenCuenta = resumen;
		this.hasAdicionales = resumen.adicionales.filter((x) => x.checked).length > 0;
		if (this.planActual) {
			resumen.adicionales.forEach((x) => (x.fechaInicio = this.planActual.fechaCaducidad));
		}
	}

	updatePlan(plan: Plan) {
		this.planSeleccionado = plan;
		setTimeout(() => {
			this.pagoService.triggerCalculations();
		}, 0);
		//this.planUsuarioService.triggerCalculations();
	}

	mostrarVentanaWebPay(): boolean { //Método excusivo para testing
		const attribute = document.body.getAttribute('data-mostrar-webpay');
		if (!attribute) {
			return true;
		}
		return attribute !== 'false';
	}

	pagar(type: string) {
		if (this.resumenCuenta.abono && this.resumenCuenta.abono > 0 && type == "change") {
			this.resumenCuenta.idPlanUsuarioAntiguo = this.planActual.idPlanUsuario;
			var planBase = this.planes.find((x) => x.id === this.planActual.idPlanSf);
			if(this.planActual.maxUsuarios > planBase.usuarios) {
				Swal.fire({
					icon: "error",
					title: "Error en el cambio de plan",
					text: "Se detecto que cuentas con un plan que supera el número de usuarios del plan seleccionado. Por favor, contacta a soporte para realizar el cambio.",
				}).then((result) => {
					this.loading = false;
					this.ref.detectChanges();
					if (result.value) {
						this.paymentPlanModal.close();
					}
				});
				return;
			}
		}
		this.resumenCuenta.idDatosFacturacion = this.datosFacturacion.emisorDatosId;
		this.resumenCuenta.idEmisor = this.datosFacturacion.emisorId;
		this.resumenCuenta.idUsuario = this.usuarioId;
		this.resumenCuenta.idPlanSf = type == "change" ? this.planSeleccionado.id : this.planActual.idPlanSf;
		this.resumenCuenta.certificaciones = this.certificaciones;
		this.resumenCuenta.payment = true;
		this.loading = true;
		this.planService.doPayment(this.resumenCuenta).subscribe(
			(result) => {
				if (result.status == 200) {
					if (result.data.pago == "webpay") {
						if (this.mostrarVentanaWebPay()) {
							var form = document.createElement("form");
							form.method = "post";
							form.target = "_blank";
							form.action = result.data.url;
							document.body.appendChild(form);

							var input = document.createElement("input");
							input.type = "hidden";
							input.name = "token_ws";
							input.value = result.data.token;
							form.appendChild(input);
							form.submit();

							this.pollPaymentStatus(result.data.token).subscribe((paymentCompleted) => {
								this.loading = false;
								this.ref.detectChanges();
								if (paymentCompleted) {
									// Ejecutar la verificación de Transbank y continuar con la generación de la factura
									Swal.fire({
										icon: "success",
										title: "Pago realizado",
										text: "Se ha extendido exitosamente tu plan.",
									}).then((result) => {
										if (result.value) {
											this.paymentPlanModal.close();
											this.loadData();
										}
									});
								} else {
									Swal.fire({
										icon: "warning",
										title: "Empresa Ingresada",
										text: "No obtuvimos respuesta del pago. Si se efectuó será procesado en breves minutos.",
									}).then((result) => {
										if (result.value) {
											this.paymentPlanModal.close();
											this.loadData();
										}
									});
								}
							});
						}
						else { //Se setea el test como pagado
							this.cypressService.processManualPayment(true, this.resumenCuenta.total).subscribe(data => {
								this.loading = false;
								this.ref.detectChanges();
								if (data.status == 200) {
									Swal.fire({
										icon: "success",
										title: "Empresa Ingresada",
										text: "Se ha ingresado exitosamente la empresa " + this.datosFacturacion.razonSocial + ". Debes iniciar sesión de nuevo para operar con tu empresa.",
									}).then((result) => {
										if (result.value) {
											this.paymentPlanModal.close();
											this.authService.logout();
										}
									});
								}
							});
						}
						//this.router.navigate(result.data.url);
					} else {
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Pago realizado",
							text: "Operación terminada. Si el pago fue realizado con éxito se verá reflejado en breves segundos",
						}).then((result) => {
							if (result.value) {
								this.paymentPlanModal.close();
								this.loadData();
							}
						});
					}
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Ingresar Emisor",
					text: "No se ha podido registrar el pago" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	private pollPaymentStatus(token: string, maxAttempts: number = 25, pollingInterval: number = 4000): Observable<boolean> {
		let completed = false;
		let attempts = 0;
		return interval(pollingInterval).pipe(
			takeWhile(() => !completed && attempts < maxAttempts),
			switchMap(() => {
				attempts++;
				return this.emisorService.verifyTransbank(token);
			}),
			map((response: Response<boolean>) => {
				return response.data;
			}),
			tap((success: boolean) => {
				if (success) {
					completed = true;
					this.loading = false;
				}
			}),
			last(),
			catchError(() => of(false))
		);
	}

	actualizarPago(resumen) {
		this.resumenCuenta = resumen;
	}

	actualizarCertificaciones(certificaciones) {
		this.certificaciones = certificaciones;
	}

	openFacturas(modalRef) {
		this.planService.getFacturasByPlan(this.planActual.idPlanUsuario).subscribe((data) => {
			this.facturasPlan = data;
		});

		this.paymentPlanModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	openAdicionales(modalRef) {
		this.emisorService.getAdicionales(this.planActual.emisorId).subscribe((data) => {
			this.adicionales = data;
		});

		this.paymentPlanModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "xl",
			centered: true,
		});
	}

	openUsuarios() {
		this.router.navigateByUrl("/mantenedores/usuarios");
	}

	openPDF(idFactura) {
		this.loading = true;
		this.ref.detectChanges();
		this.planService.getFacturaPDF(idFactura).subscribe((data) => {
			this.loading = false;
			this.ref.detectChanges();
			let pdfBlob = this.utilities.convertB64ToBlob(data.data, "application/pdf");
			let pdfUrl = URL.createObjectURL(pdfBlob);
			this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
		});
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}
	public get abonoFechaInicio(): moment.Moment {
		// Supongamos que el abono parte el primer día del mes siguiente a hoy
		// O ajusta según tu lógica real
		const hoy = moment();
		const primerDiaAbono = moment({ year: hoy.year(), month: hoy.month(), day: 1 });
		if (hoy.date() > 1) {
		primerDiaAbono.add(1, 'months');
		}
		return primerDiaAbono;
	}

	get abonoFechaFin(): moment.Moment {
		// Último día de abono, ajusta si tienes la info exacta
		// Por ejemplo, planActual.fechaCaducidad
		return moment(this.planActual.fechaCaducidad);
	}
}
